import script from "./InviteForm.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./InviteForm.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./InviteForm.vue3.vue?vue&type=style&index=0&id=ad569d3a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad569d3a"]])

export default __exports__